<template>
  <div class="box11">
    <div class="block" ref="block"></div>
    <div class="titleBox">
      <div class="title">
        500+全套短视频系统课程<br />每周实时更新抖音新玩法
      </div>
      <div class="subtitle">一个问题N种解法，从0到1短视频涨粉变现全攻略</div>
    </div>
    <div class="box4-btm-box">
      <div class="box4-btm">
        <div
          class="subject-box"
          v-for="(item, index) in list"
          :key="index"
          ref="item"
          @click="goTop(index)"
          :style="{
            backgroundColor:
              cur == index && showAnswer ? '#fff' : 'transparent',
          }"
        >
          <div class="subject" @click="changeCur(index)">
            <div class="title">
              <p>{{ item.chapter }}</p>
              {{ item.nav }}
            </div>
            <div
              class="icon"
              :class="{ 'img-rotate': cur == index && showAnswer }"
            >
              <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
            </div>
          </div>

          <div
            class="course-content"
            :class="{ 'show-answer': cur == index && showAnswer }"
          >
            <div class="line"></div>
            <div class="title-icon">
              <img
                class="img1"
                src="../../../assets/coursePage/media/box11/1.png"
                alt
              />主要内容
            </div>
            <div class="main-content">
              <div class="main-text2" v-for="i in item.content" :key="i">
                <p>{{ i }}</p>
              </div>
            </div>

            <div class="title-icon">
              <img
                class="img2"
                src="../../../assets/coursePage/media/box11/2.png"
                alt
              />可掌握的核心能力
            </div>
            <div class="main-text">
              <p>{{ item.ability }}</p>
            </div>

            <div class="title-icon">
              <img
                class="img3"
                src="../../../assets/coursePage/media/box11/3.png"
                alt
              />可解决的实际问题
            </div>
            <div class="main-text3">
              <p v-for="k in item.problem" :key="k">{{ k }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import check from "../../../utils/check";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          chapter: "第一章",
          nav: "掘金训练营第一课",
          content: [
            "掘金陪跑训练营导学",
            "平台变现模式汇总",
            "账号定位",
            "提高覆盖群体的定位方法",
            "2000万粉丝垂类账号定位方式",
            "3个作品涨粉40万的定位公式",
            "提高视频完播率的定位公式",
            "给用户长期关注的定位公式",
            "14天涨粉30万的定位公式",
            "变现能力强涨粉速度快的账号定位",
            "基础班升级运营班的作业要求",
            "平台内容机制和推荐算法",
            "......",
          ],
          ability: "能够用多种方法定位自己的抖音账号，为后续内容创作做准备。",
          problem: ["解决个人账号定位问题，解决不知道抖音拍什么的问题。"],
        },
        {
          chapter: "第二章",
          nav: "拍摄剪辑招式",
          content: [
            "【文本】云雾消散文字效果",
            "【贴纸】绽放心心大爆炸玩法-给视频增加热门素材元素",
            "【特效】大片感片头效果-提升视频专业度",
            "【特效】制作超酷的片头出字出场效果",
            "【调色】电影感的色彩调色方法-适合外景暗色视频",
            "【调色】画中画+蒙版调色方法",
            "【关键帧】让别人无法去除的文字乱飞水印效果",
            "【关键帧】控制音量高低达到提升用户听觉感",
            "【关键帧】文字扫光效果-增加科技感效果",
            "【关键帧】控制不透明度-适合伤感回忆类视频",
            "【关键帧】模拟运动镜头-适合颜值类账号",
            "【关键帧】视频希区柯克变焦效果-突显主体",
            "【背景】带背景的视频效果-加强视频专业度",
            "【抠像】利用色度抠图制作开门回家转场效果",
            "【抠像】人物定格出场效果-重要人物出场玩法",
            "......",
          ],
          ability: "能够熟练掌握各种剪辑手法、特效制作。",
          problem: ["能够熟练掌握剪辑技巧，快速剪辑视频作品。"],
        },
        {
          chapter: "第三章",
          nav: "内容为王",
          content: [
            "适合普通人的变现方式",
            "适合企业的变现模式",
            "如何做个人定位",
            "如何做企业定位",
            "如何打造人设记忆点",
            "账号如何搭建",
            "如何找对标账号",
            "如何规划爆火的内容赛道",
            "短视频如何才能上大热门",
            "爆款选题的3种选题方式",
            "爆款标题的写作方法",
            "dou平台快速写脚本的方式方法",
            "爆火案例内容趋势解析",
            "通用的爆款案例拆解方法",
            "......",
          ],
          ability: "知道各类短视频变现途径，能够拆解分析各类爆款视频。",
          problem: ["了解不同类型账号的变现形式；", "具备短视频内容输出能力。"],
        },
        {
          chapter: "第四章",
          nav: "短视频标题51招",
          content: [
            "居高望远法写标题",
            "真心话法写标题",
            "特写镜头法写标题",
            "变变变法写标题",
            "痛点和爽点法写标题",
            "十分迫切法写标题",
            "先人一步法",
            "世上无难事法写标题",
            "轻而易举法写标题",
            "当个知音法写标题",
            "悄悄话法写标题",
            "看别人说自己法写标题",
            "让他得到法",
            "心里有数法",
            "迫切低问法",
            "比较式问句法",
            "......",
          ],
          ability: "熟练具备撰写短视频标题的能力。",
          problem: ["掌握51个招式写标题的方法。"],
        },
        {
          chapter: "第五章",
          nav: "爆款视频前3秒如何设计50招",
          content: [
            "假装法-设计",
            "借势法-设计",
            "偷偷告诉你法-设计",
            "挑战法-设计",
            "运镜动态法-设计",
            "宝藏分享法-设计",
            "快速闪进法-设计",
            "夸大其词法-设计",
            "交底法-设计",
            "转变思维法-设计",
            "人群造势法-设计",
            "打招呼法-设计",
            "视角反差法-设计",
            "快节奏法-设计",
            "对比代入法-设计",
            "音效法-设计",
            "定格帧法-设计",
            "......",
          ],
          ability: "掌握视频前三秒设计技巧。",
          problem: ["有效提高视频前五秒的完播率。"],
        },
        {
          chapter: "第六章",
          nav: "如何写爆款文案40招",
          content: [
            "解析1亿播放量的文案是如何撰写的",
            "700万播放量口播文案公式",
            "标题文案的5个套路",
            "快速写文案的核心心法",
            "让你写文案速度大大提高的文案公式",
            "销售文案-如何设计马上下单的文案",
            "学会1招，让你视频完播率翻10倍",
            "一个方法让客户立即下单",
            "解析推文转化率10.6%赚113万营业额",
            "可直接套用的文案模板",
            "解析月涨粉400万的文案核心要点",
            "解析上热榜的文案结构",
            "长文案结构拿起来就能写",
            "故事型服务型文案公式",
            "高点击率视频文案的共性",
            "3个心理学小知识",
            "......",
          ],
          ability: "具备短视频爆款文案撰写能力。",
          problem: ["能够熟练撰写短视频脚本文案。"],
        },
        {
          chapter: "第七章",
          nav: "搜索流量布局",
          content: [
            "搜索流量需要知道的核心价值",
            "什么是搜素流量",
            "搜索流量算法的底层逻辑",
            "如何拓展关键词",
            "布局关键词的技巧",
            "视频如何排名靠前",
            "新号如何排名靠前",
            "如何获得商场的搜索流量",
            "......",
          ],
          ability: "掌握布局搜索流量技巧。",
          problem: ["有效提高账号搜索流量数据。"],
        },
        {
          chapter: "第八章",
          nav: "抖音短视频（直播）推广投放30招",
          content: [
            "利用小店随心推“智能优化法”进行电商带货的推广",
            "利用小店随心推“暴力三步走法”迅速打通直播间精准标签",
            "投放无素材，无需烧脑制作高ROI产品比投放素材",
            "利用小店随心推配合PC千川浅层计划双轨起号法",
            "新户PC千川冷启动方法与推流底层逻辑的优化方法",
            "千川素材短视频制作要点及公式",
            "千川徕卡建模（大行为小兴趣，小行为大兴趣）实操方法",
            "千川出价计算公式（高效实现跑量又省成本）",
            "千川达摩盘DMP人群包的深度解析",
            "新账号起号怎么投放dou+",
            "常规dou+投放公式实操案例",
            "什么条件下才能投放智能推荐",
            "dou+30%最低成本测试原理实操案例",
            "......",
          ],
          ability: "熟练掌握小店随心推、千川、抖加的投放技巧。",
          problem: ["利用付费流量撬动自然流量，实现弯道超车。"],
        },
        {
          chapter: "第九章",
          nav: "抖店运营30招",
          content: [
            "如何高效提升店铺装修停留时间与转化",
            "关键词布局打入搜索流量池的商品创建法",
            "如何做好商品卡流量，提升商品点击卡",
            "一步三招，高效提升店铺体验分，不花一分冤枉钱",
            "抖音店铺联盟计划的设置及相关要求",
            "如何找达人进行带货自己的商品提升店铺GMV",
            "低价双运费方法进行店铺操作",
            "数量叠加法创建商品，提升商品点击",
            "店铺主页装修思路详讲",
            "飞鸽客服及体验分维护售后处理",
            "营销功能使用打造爆品商品",
            "影响转化因素的产品5张主图如何设计",
            "抖店商品如何设定价格不影响店铺排名",
            "抖店电商数据如何与千川配合获得精准店铺流量",
            "教育类课程入驻抖店的标准流程--学浪计划建立",
            "......",
          ],
          ability: "熟练掌握抖店运营技巧。",
          problem: ["能够利用抖音小店获取更多流量进行转化。"],
        },
        {
          chapter: "第十章",
          nav: "直播运营121问",
          content: [
            "直播10种开场话术解析",
            "直播10种优质转款话术解析",
            "直播10种优质开价话术解析",
            "直播间核心数据之直播间重要数据曝光次数",
            "直播间核心数据之直播间重要数据曝光点击率",
            "直播间核心数据之直播间重要数据千次观看成交",
            "直播内容数据之直播间观看互动率",
            "直播间场次时长复盘",
            "直播成交数据复盘",
            "如何快速过千川学习期",
            "直播间投放为什么只能短暂跑量",
            "......",
          ],
          ability: "学习全体系直播课程，熟练掌握直播全流程。",
          problem: ["熟悉直播间搭建人、货、场。"],
        },
        {
          chapter: "第十一章",
          nav: "人设IP打造",
          content: [
            "什么是人设IP",
            "人设IP模式的崛起",
            "人设IP商业模式的爆发和趋势",
            "人设IP的三维定位法则",
            "人设IP定位的秘密武器",
            "人设IP账号的极速cosplay人设定位法",
            "经典人设IP账号的案例解读",
            "为什么要进行高热IP类账号文案的仿写",
            "关键词寻找同类IP的高热文案",
            "高热文案的改编和仿写",
            "文案开头语和结尾语的设计",
            "人物特有口头禅的设计",
            "人设内容配合专业性内容的展示",
            "爆点狙击式的脚本文案写作",
            "利用连续引爆法实现人设IP账号数据的持续增长",
            "......",
          ],
          ability: "了解做人设IP账号的全流程。",
          problem: ["能够打造一个成功的人设IP账号。"],
        },
        {
          chapter: "第十二章",
          nav: "短视频好物种草带货3.0玩法",
          content: [
            "如何选赛道",
            "如何找对标达人",
            "如何拍摄、剪辑视频",
            "对标达人的爆款视频",
            "爆款商品爆款视频怎么选",
            "dou+怎么投",
            "小店随心推什么时候停",
            "......",
          ],
          ability: "掌握做一个好物带货起号的玩法流程。",
          problem: [
            "能够解决在打造种草类账号的各种操作（包括如何选品、找对标达人、找爆款视频等）过程中遇到的实际问题。",
          ],
        },
      ],
      prevItemHeight: 0,
      cur: -1,
      showAnswer: true,
    };
  },
  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box11 {
  padding: 0px 0 72px;
  width: 100%;
  background: #f2f0ff;
  .block {
    height: 80px;
  }
  .titleBox {
    text-align: center;
    // margin-top: -10px;
    font-family: PingFangSC-Semibold;
    .title {
      font-size: 40px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #0d004d;
      line-height: 62px;
    }
    .subtitle {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #555266;
      line-height: 40px;
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }

  .subject-box {
    margin: 0 auto;
    margin-bottom: 16px;
    width: 686px;
    overflow: hidden;
    border-radius: 16px;
  }
  .subject-box:nth-child(2) {
    .main-content {
      .main-text2 {
        p {
          text-indent: -13px;
          padding-left: 13px;
        }
      }
      .main-text2:last-child {
        margin-left: 60px;
      }
    }
  }
  .subject {
    display: flex;
    align-items: center;
    position: relative;
    padding: 22px 0px 22px 35px;
    padding-right: 22px;
    width: 100%;
    height: 96px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;
    z-index: 5;
    justify-content: space-between;

    .title {
      margin-right: 20px;

      display: flex;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #020941;
      line-height: 40px;
      p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 40px;
        color: #826aff;
        margin-right: 16px;
      }
    }

    .icon {
      width: 28px;
      height: 28px;
      transition: 0.5s ease all;
      margin-right: 5px;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .img-rotate {
      transition: 0.5s ease all;
      transform: rotate(180deg);
    }

    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
  }

  .course-content {
    padding: 0px 40px 0px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    max-height: 0;
    opacity: 0;
    transition: 0.3s ease all;
    overflow: hidden;
    z-index: 3;

    .line {
      margin-bottom: 28px;
      width: 622px;
      margin-left: -8px;
      height: 1px;
      background: #F2F3F5;
    }
  }

  .show-answer {
    padding: 0px 40px 0px;
    border-radius: 16px;
    // display: block;
    max-height: 1600px;
    opacity: 1;
    transition: 0.4s ease all;
  }

  .title-icon {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: #1d2129;
    img {
      margin-right: 14px;
      width: 32px;
      height: 32px;
    }
  }

  .main-content {
    margin-bottom: 40px;
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
  }
  .main-content .main-text2:last-child {
    p {
      &::before {
        display: none;
      }
    }
  }
  .main-text {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;
    line-height: 40px;
    margin-top: 4px;
    margin-bottom: 40px;
    margin-left: 45px;
  }
  .main-text2 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;

    width: 100%;
    margin-bottom: 5px;
    margin-left: 45px;
    p {
      line-height: 40px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
  .main-text3 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #66666c;
    line-height: 40px;
    padding-bottom: 32px;
    margin-top: 4px;
    margin-left: 45px;
  }
}
</style>
